import { Badge } from '@mantine/core';
import { useUnreadNotificationsCount } from '@/queries/notifications/useUnreadNotificationsCount';

export function NotificationBadge() {
  const { data } = useUnreadNotificationsCount();
  const unreadCount = data?.data;

  if (!unreadCount) {
    return null;
  }

  return <Badge>{unreadCount}</Badge>;
}
